export default "__VITE_ASSET__DiqqagBG__"